import BaseAPI from '@/apis/base/baseApi';

class WatchlistAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'watchlist';
}

export default new WatchlistAPI();
